import { Component, OnInit, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { MAT_DIALOG_DATA, MatButtonModule, MatDialogRef } from '@angular/material';

import { DServicio, DRespuestaSimple, DContextoMuisca } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DParametrosPolitica, DParametroPolitica, DValorDominio, DLugar } from '@dian/api-basicos-parametricas';
import { DReciboPago490Servicios, DLiquidacionRecibo, DRtaLiquidacionReciboPago, DConceptoLiquidacionRecibo, DListEntidadesBancarias, DEntidadBancaria, DDeudorSolidarioSubsidiario } from '@dian-api/recibo-pago490';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/recibo-pago/src/servicios/doperaciones-matematicas.servicio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'modal-id-tributario',
  templateUrl: './modalidtributario.component.html',
  styleUrls: ['./modalidtributario.component.css'],
  providers: [
    DReciboPago490Servicios,
    DBasicosParametricasServicios,
    DServicio,
    DatePipe
  ]  
})
export class ModalIdTributarioComponent implements OnInit {
  public idTributario:string= '0';
  constructor(
    public dialogRef: MatDialogRef<ModalIdTributarioComponent>,
    // @Inject(MAT_DIALOG_DATA) 
    // public data: {idTributario:string}={0}
    ){
    }
    ngOnInit(): void {
    this.idTributario='1111';
    
  }
    onNoClick(): void {
      this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/modal/modalidtributario.component.ts